import SubscribeForm from "./SubscribeForm";

const floaters = [
  { emoji: "🎮", left: "5%", duration: "18s", delay: "0s" },
  { emoji: "⚽", left: "20%", duration: "22s", delay: "3s" },
  { emoji: "🧩", left: "38%", duration: "16s", delay: "7s", size: "1.4rem" },
  { emoji: "🏎️", left: "55%", duration: "24s", delay: "1s" },
  { emoji: "🃏", left: "72%", duration: "19s", delay: "5s", size: "1.4rem" },
  { emoji: "🎯", left: "88%", duration: "21s", delay: "9s" },
  { emoji: "💥", left: "14%", duration: "25s", delay: "12s", size: "1.3rem" },
  { emoji: "🏀", left: "62%", duration: "17s", delay: "6s" },
];

export default function Hero() {
  return (
    <section className="hero">
      <div className="floaters" aria-hidden="true">
        {floaters.map((f, i) => (
          <span
            key={i}
            className="floater"
            style={{
              left: f.left,
              animationDuration: f.duration,
              animationDelay: f.delay,
              fontSize: f.size || "1.8rem",
            }}
          >
            {f.emoji}
          </span>
        ))}
      </div>
      <h1>
        الملل ما عنده
        <br />
        <em>مكان في شليل للألعاب!</em>
      </h1>

      <p className="hero-sub">
        أكتر من 100 لعبة أكشن، رياضة، بازل، وكتير كمان — كلها في موبايلك. بدون
        تحميل، بدون تأخير.
      </p>

      <SubscribeForm />
    </section>
  );
}
